import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Polyline, { points: "18 15 12 9 6 15", stroke: `${color}` })
    }
  );
};
Icon.displayName = "ChevronUp";
const ChevronUp = memo(themed(Icon));
export {
  ChevronUp
};
//# sourceMappingURL=chevron-up.js.map
